import { AssignedProjectsPage } from './AssignedProjectsPage'

export function SupplierDashboard() {
  return <AssignedProjectsPage title="Supplier Dashboard" field="supplierUid" />
}
